import styled from 'styled-components';

export const Button = styled.button`
  background: #626ed4;
  border: 0;
  padding: 10px 15px;
  border-radius: 4px;
  color: #fff;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  /* text-align: center; */
  
  #title {
      color: #fff;
      padding: 10px 0;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
      text-align: center;
  }

  span {
    padding: 10px 0;
    font-size: 14px;
  }
`;

export const ModalMenus = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    flex: 1;
    background: #ec4561;
    border: 0;
    padding: 15px 0;
    border-radius: 4px;
    color: #fff;

    & + button {
      margin-left: 10px;
      background: #626ed4;
    }
  }
`;
